import { ErrorDescription } from 'ethers';
import { Subscription } from 'rxjs';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { inject } from '@angular/core';
import { DhrQuarkusService } from './services/dhr.service';
import { PythonService } from './services/python.service';
import { TypescriptService } from './services/typescript.service';
export type funcionDecoder = (reason: any) => ErrorDescription | null;
export abstract class AbstractComponent {
  ARRAY_MAX_ELEMENTOS: number = 10000;
  subscriptions!: Subscription;
  FORMATO_FECHA = 'yyyy-MM-dd HH:mm:ss';
  dhrService = inject(DhrQuarkusService);
  pythonService = inject(PythonService);
  typescriptService = inject(TypescriptService);

  protected parseDate(date: number) {
    return new Date(Number(date) * 1000).toLocaleString();
  }
  protected parseDateMilisegundos(date: number) {
    return new Date(Number(date)).toLocaleString();
  }
  protected parseInt(cadena: string) {
    return parseInt(cadena);
  }
  protected getJSON(object: any): string {
    return JSON.stringify(object, null, 2)
    /*
    console.log(`AbstractComponent.getJSON(${object})`);
    return JSON.stringify(
      object,
      (key, value) => {
        typeof value === 'bigint' ? value.toString() : value; // return everything else unchanged
      },
      2
    );
    */
  }
  errorMetamaskNoDetectado: ModalOptions = {
    initialState: {
      list: [
        'Se necesita un pluging compatible con EIP-1993, como metamask' /*, 'Pass your data', 'Do something else', '...'*/,
      ],
      title: 'Plugin metamask no detectado.',
    },
  };
  errorMetamaskBloqueado: ModalOptions = {
    initialState: {
      list: [
        'Es necesario desbloquear metamask para ejecutar la operacion' /*, 'Pass your data', 'Do something else', '...'*/,
      ],
      title: 'Plugin metamask bloqueado',
    },
  };
}
